import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getLogosForSubsite = async () => {
  	var response = await axios
    	.get(process.env.REACT_APP_API_URL + "/admin/logos/subsite", { headers: AuthHeader.authHeader() });
		console.log("Get NC Item", response.data);

	    return response.data;
};
const getLogos = async () => {
	var response = await axios
	  .get(process.env.REACT_APP_API_URL + "/admin/logos", { headers: AuthHeader.authHeader() });
	  console.log("Get NC Item", response.data);

	  return response.data;
};
const getLogoLocations = async () => {
  	var response = await axios
    	.get(process.env.REACT_APP_API_URL + "/admin/logos/locations", { headers: AuthHeader.authHeader() });
		console.log("Get Logo Locations", response.data);

	    return response.data;
};
const getLogoColors = async () => {
	var response = await axios
	  .get(process.env.REACT_APP_API_URL + "/admin/logos/colors", { headers: AuthHeader.authHeader() });
	  console.log("Get Logo Colors", response.data);

	  return response.data;
};

const updateLogoPositionForStyle = async (newLogoPosition) => {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/logo/style/position", 
    { newLogoPosition }, 
    { headers: AuthHeader.authHeader()});
    return response.data;
};

const addLogo = async (newLogo) => {
	const response = await axios.put(process.env.REACT_APP_API_URL + "/admin/logo", 
	{ newLogo }, 
	{ headers: AuthHeader.authHeader()});
	return response.data;
};

const deleteLogo = async (subsitDecorationId) => {
	const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/logo/" + subsitDecorationId, 
	{ headers: AuthHeader.authHeader()});
	return response.data;
};

const toggleLight = async ( subsiteDecorationId, productId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/logo/togglelight", 
	{   
		subsiteDecorationId: subsiteDecorationId,
		productId: productId
	}, 
	{ headers: AuthHeader.authHeader()});
	return response.data;
};

const addEditLogo = async (logo) => {
	console.log("Logo", logo);
	const data = new FormData();

	data.append('decorationName', logo.decorationName);
	data.append('code', logo.code);
	data.append('decoType', logo.decoType);
	data.append('price', logo.price);
	data.append('imageUrl', logo.uploadedImage[0]);
	data.append('decoColorId', logo.decoColorId);
	data.append('id', logo.id);
  
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/logo/addedit", data,
	  {
		headers: {
		  ...AuthHeader.authHeader(),
		  'Content-Type': 'multipart/form-data'
		}
	  });
  
	console.log("RESPONSE", response);
	return response.data;
  
  };
  
const addAvailableLogo = async (logo) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/availablelogo", 
	{ logo }, 
	{ headers: AuthHeader.authHeader()});
	return response.data;
}

const deleteAvailableLogo = async (logoId) => {
	const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/availablelogo/" + logoId, 
	{ headers: AuthHeader.authHeader()});
	return response.data;
};

const getAvailableLogos = async () => {
	var response = await axios
	  .get(process.env.REACT_APP_API_URL + "/admin/availablelogos", { headers: AuthHeader.authHeader() });
	  
	  return response.data;
};

const LogoService = {
    getLogosForSubsite,
	getLogos,
	updateLogoPositionForStyle,
	getLogoLocations,
	addLogo,
	deleteLogo,
	toggleLight,
	getLogoColors,
	addEditLogo,
	addAvailableLogo,
	deleteAvailableLogo,
	getAvailableLogos,
};
export default LogoService;